// @flow
export default (theme: Object) => ({
    link: {
        cursor: 'pointer',
    },
    title: {
        wordBreak: 'break-word',
    },
    location: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
    },
    locationTitle: {
        // fontWeight: 600,
    },
    locationAddress: {
        color: 'rgba(0, 0, 0, 0.54)',
    },
    assignee: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
    },
    status: {
        fontStyle: 'italic',
    },
    unassigned: {
        color: 'rgba(0, 0, 0, 0.54)',
    },
    datetime: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        flexShrink: 0,

        '& > :nth-child(2)': {
            color: 'rgba(0, 0, 0, 0.54)',
        },
    },
    autoPayWarning: {
        fontSize: 14,
        color: theme.palette.error.main,
    },
});
